<template>
  <md-table v-model="plants" class="table-striped" table-header-color="primary">
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Serial No">
        <div v-if="item.stateId < 3">
          <span v-if="item.stateId === 2">
            <Badge :type="state(item.stateId).colour">{{
              state(item.stateId).name
            }}</Badge></span
          >
          &nbsp;
          <router-link :to="{ name: 'Plant', params: { plantId: item.id } }">
            {{ item.serialNo }} </router-link
          >&nbsp;&nbsp;<span v-if="item.archiveMessage"
            ><strong>Reason:</strong> {{ item.archiveMessage }}</span
          >
        </div>
        <div v-if="item.stateId === 3">
          <Badge :type="state(item.stateId).colour">{{
            state(item.stateId).name
          }}</Badge>
          &nbsp;
          {{ item.serialNo }}
        </div>
      </md-table-cell>
      <md-table-cell md-label="Location">{{ item.location }}</md-table-cell>
      <md-table-cell class="text-right">
        <state-button
          type="Reactivate"
          :role="4"
          :stateId="item.stateId"
          :canRestore="item.canRestore"
          @state-click="reactivatePlant(item.id)"
        ></state-button>
        <edit-button
          :stateId="item.stateId"
          :isSmall="true"
          @edit-click="editPlant(item.id)"
        ></edit-button
        >&nbsp;
        <state-button
          tooltip="Delete Plant"
          type="Delete"
          :stateId="item.stateId"
          :canDelete="item.canDelete"
          @state-click="deletePlant(item.id)"
        ></state-button>
        <state-button
          tooltip="Archive Plant"
          type="Archive"
          :stateId="item.stateId"
          :canDelete="item.canDelete"
          @state-click="archivePlant(item.id)"
        ></state-button>
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state md-label="No Plant Found"></md-table-empty-state>
  </md-table>
</template>

<script>
import Swal from "sweetalert2";
import $ from "jquery";
import { Badge } from "@/components";
import { mapGetters } from "vuex";

export default {
  name: "PlantList",
  components: {
    Badge
  },
  computed: {
    ...mapGetters({
      plants: "data-management-client/plants",
      state: "state"
    })
  },
  methods: {
    async getPlantListing() {
      this.$store.dispatch(
        "data-management-client/getPlantListing",
        this.$route.params.buildingId
      );
    },
    editPlant(id) {
      this.$router.push({
        name: "Edit Plant",
        params: { plantId: id }
      });
    },
    deletePlant(plantId) {
      Swal.fire({
        text: `Are you sure you want to delete this?`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("data-management-client/deletePlant", plantId)
            .then(() => {
              this.getPlantListing();
            })
            .catch(error => {
              this.$notify({
                message: error.response.data,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    },
    archivePlant(plantId) {
      Swal.fire({
        title: "Archive plant?",
        html: `<div class="md-field md-theme-default"><span>Message:&nbsp;</span><br/>
            <input type="text" id="md-input" class="md-input">
            </div>`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        confirmButtonText: "Yes, archive it!",
        cancelButtonClass: "md-button md-danger",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("data-management-client/archivePlant", {
              id: plantId,
              message: $("#md-input").val()
            })
            .then(() => {
              this.getPlantListing();
            })
            .catch(error => {
              this.$notify({
                message: error.response.data.errors.Message[0],
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    },
    reactivatePlant(plantId) {
      this.$store
        .dispatch("data-management-client/reactivatePlant", plantId)
        .then(() => {
          this.getPlantListing();
        })
        .catch(error => {
          this.$notify({
            message: error.response.data,
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        });
    }
  }
};
</script>

<style></style>
